import useSWR from 'swr'
import { apiService } from '../utils/prefetchManager'

// Polls while backend returns action=LOADING, otherwise stops
export function useKeywordSearchSWR({ keyword, page = 1, platform = '', filters = {}, intervalMs = 5000, legacy = false }) {
  const key = keyword ? ['keyword-search', keyword, page, platform, JSON.stringify(filters), legacy] : null

  const fetcher = async () => {
    const response = await apiService.fetchKeywordSearchResults(keyword, page, platform, filters, { legacy })
    return response
  }

  const swr = useSWR(key, fetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: true,
    // Dynamic refresh interval based on server response
    refreshInterval: (latestData) => {
      if (!latestData) return 0
      // Backend returns { action: 'LOADING', code: 200 } while processing unknown keywords
      if (latestData?.action === 'LOADING') {
        return intervalMs // e.g., 5000ms = 5s; caller can pass 10000 for 10s
      }
      return 0
    },
  })

  return swr
}


